import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
declare function loadingServiceShow(zindex, id, flag);
declare function loadingServiceHide(id);
export interface ICustomWindow extends Window {
  __customer_global_stuff: string;
  loadingServiceShow: (zindex: number, id: string, flag: boolean) => void;
  loadingServiceHide: (id: string) => void;
}
function getWindow(): any {
  return window;
}
function emailFirstLetterValidator(
  control: AbstractControl
): { [key: string]: boolean } | null {
  if (control.value != undefined) {
    let value = control.value.charAt(0);
    let check = value && value.match(/[a-z]/i);
    if (check == null) {
      return { wrongMail: control.value };
    }
  }
  return null;
}
@Injectable({
  providedIn: 'root',
})
export class ValueService {
  appconstant = 'http://3.7.237.134:8080/kuttystory/';
  Emailvalidator = emailFirstLetterValidator;
  incubatorDistrict: any;
  projectName: any;
  constructor(private Router: Router, private http: HttpClient) {}
  get nativeWindow(): ICustomWindow {
    return getWindow();
  }
  isVisibleSource: BehaviorSubject<boolean> = new BehaviorSubject(false);

  /**
   * A method to show and hide the loader.
   * @param value - The value to show or hide the loader. It can be either 'show' or 'hide'.
   * If the value is 'show', the loader will be shown. If the value is 'hide', the loader will be hidden.
   */
  amizhthLoader(value) {
    if (value === 'show') {
      // Show the loader
      loadingServiceShow(999, 'loader', true);
    }
    if (value === 'hide') {
      // Hide the loader
      loadingServiceHide('loader');
    }
  }
  /**
   * Navigate to the CSR project details page with the given project id as a query parameter.
   * This is used to view details of a specific CSR project.
   * @param _id The project id to be passed as a query parameter.
   */
  csrprojectId(_id: string): void {
    this.Router.navigate(['/csrsavailproject/project-details'], {
      queryParams: { _id: _id },
    });
  }
  /**
   * Navigate to the CSR project details page with the given project id as a query parameter.
   * This is used by the admin dashboard.
   * @param _id The project id to be passed as a query parameter.
   */
  csrprojectId1(_id: string): void {
    this.Router.navigate(['/admin/csrsavailproject/details'], {
      queryParams: { _id: _id },
    });
  }
  /**
   * Navigate to the event details page with the given event id as a query parameter.
   * This is used by the main event navigation.
   * @param _id The event id to be passed as a query parameter.
   */
  eventId(_id: string): void {
    this.Router.navigate(['/event/details'], {
      queryParams: { _id: _id },
    });
  }
  /**
   * Navigate to the event details page with the given event id as a query parameter.
   * This is used by the admin menu.
   * @param _id The event id to be passed as a query parameter.
   */
  eventId1(_id: string): void {
    this.Router.navigate(['/admin/event/details'], {
      queryParams: { _id: _id },
    });
  }
  /**
   * Given an initiative title, navigates to the toilet page with the given
   * initiative title as a query parameter.
   * @param _title The initiative title to be passed as a query parameter.
   */
  initiativeId(_title: string): void {
    this.Router.navigate(['/toilet'], { queryParams: { _title: _title } });
  }
  /**
   * Navigates to the toilet page with the given initiative title as a query parameter.
   * @param _title The initiative title to be passed as a query parameter.
   */
  initiativeId2(_title: string): void {
    this.Router.navigate(['/toilet'], { queryParams: { _title: _title } });
    // Uncomment the line below to navigate to the ntoilet page instead
    // this.Router.navigate(['/ntoilet'], { queryParams: { _title: _title } });
  }
  /**
   * Given a blog id, navigates to the blog add page with the given blog id.
   * @param _id The blog id.
   */
  blogId(_id: string): void {
    this.Router.navigate(['/admin/blog/add'], { queryParams: { _id: _id } });
  }
  /**
   * Given a blog id, navigates to the blog details page with the given blog id.
   * @param _id The blog id.
   */
  blogDetailsId(_id: string): void {
    this.Router.navigate(['/blog/details'], { queryParams: { _id: _id } });
  }
  /**
   * Given an incubator id, navigates to the incubators details page with the given incubator id.
   * @param _id The incubator id.
   */
  incubatorId(_id: string): void {
    this.Router.navigate(['/incubators/details'], {
      queryParams: { _name: _id },
    });
  }
  /**
   * Given a district name, navigates to the incubators page with the given district name.
   * @param _id The district name.
   */
  district(_id: string): void {
    this.Router.navigate(['/incubators'], {
      queryParams: { _districtname: _id },
    });
  }
  /**
   * Navigates to the incubatee details page with the given incubatee id and name.
   * @param _id The incubatee id.
   * @param name The incubatee name.
   */
  incubeeId(_id: string, name: string): void {
    this.Router.navigate(['admin', 'incubatee', name], {
      queryParams: { _id: _id },
    });
  }
  /**
   * Given a search value, navigates to the search page with the given value.
   * @param name The search value.
   */
  searchValue(name: string): void {
    this.Router.navigate(['search'], { queryParams: { _name: name } });
  }
  /**
   * Given a status key, returns the associated color for that status.
   * @param key The status key.
   * @returns The color associated with the status key.
   */
  questionStatus(key: number): string {
    /**
     * Map of status keys to their respective colors.
     * The color values are in hex format.
     * The keys are the status key numbers.
     */
    const colorsMap = {
      0: '#F44336', // Not Answered
      1: '#E91E63', // Not Implemented
      2: '#673ab7', // Under Review
      3: '#FFC107', // Clarification Requested
      4: '#8BC34A', // Approved
      5: '#4caf50', // Score Granted
      6: '#fb4b02', // Needs Improvement
      7: '#607d8b', // Saved
    };
    let colorsVal;
    if (colorsMap.hasOwnProperty(key)) {
      colorsVal = colorsMap[key];
    } else {
      colorsVal = key;
    }
    return colorsVal;
  }
  /**
   * Given a status key, returns the associated width for that status.
   * @param key The status key.
   * @returns The width associated with the status key.
   */
  statusWidth(key) {
    const widthMap = {
      0: '135px', // Not Answered
      1: '150px', // Not Implemented
      2: '135px', // Under Review
      3: '185px', // Clarification Requested
      4: '110px', // Approved
      5: '135px', // Score Granted
      6: '170px', // Needs Improvement
      7: '100px', // Saved
    };
    let widthVal = '';
    if (widthMap.hasOwnProperty(key)) {
      widthVal = widthMap[key];
    } else {
      widthVal = key;
    }
    return widthVal;
  }
  /**
   * Given a status key, returns the associated status name for that status.
   * @param key The status key.
   * @returns The status name associated with the status key.
   */
  StatusName(key): string {
    const nameMap = {
      0: 'Not Answered', // 0
      1: 'Not Implemented', // 1
      2: 'Under Review', // 2
      3: 'Clarification Requested', // 3
      4: 'Approved', // 4
      5: 'Score Granted', // 5
      6: 'Needs Improvement', // 6
      7: 'Saved', // 7
    };
    let nameVal = '';
    if (nameMap.hasOwnProperty(key)) {
      nameVal = nameMap[key];
    } else {
      nameVal = key;
    }
    return nameVal;
  }
  /**
   * Given a status key, returns the associated color for that status.
   * @param key The status key.
   * @returns The color associated with the status key.
   */
  registerStatus(key) {
    let colorsMap = {
      Yes: '#4caf50', // green
      No: '#F44336', // red
    };
    let colorsVal = '';
    if (colorsMap.hasOwnProperty(key)) {
      colorsVal = colorsMap[key];
    } else {
      colorsVal = key;
    }
    return colorsVal;
  }
}
